import jsPDF from "jspdf";
import "jspdf-autotable";
import {
  BadgeCheck,
  Building2,
  IndianRupee,
  TrendingUp,
  UserCheck,
} from "lucide-react";

const handleDownloadPDF = (analysisResult) => {
  try {
    const data =
      analysisResult?.openAIResponse?.results ||
      analysisResult?.analysisData?.results ||
      analysisResult?.results?.[0]?.analysis?.results ||
      {};

    console.log("handleDownloadPDF - data:", data);

    const doc = new jsPDF("p", "pt", "a4");
    let yPos = 40;

    // Title
    doc.setFontSize(16);
    doc.text("Employment Payslip Analysis Report", 40, yPos);
    yPos += 40;

    // Employee & Employer Details
    doc.setFontSize(14);
    doc.text("Employee & Employer Details", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(
      `Name: ${
        data.employmentDetails?.employeeName ||
        data.employeeDetails?.name ||
        data.employeeName ||
        "N/A"
      }`,
      40,
      yPos
    );
    doc.text(
      `Employee ID: ${
        data.employmentDetails?.employeeId ||
        data.employeeDetails?.id ||
        data.employeeId ||
        "N/A"
      }`,
      300,
      yPos
    );
    yPos += 15;
    doc.text(
      `PAN/Aadhar: ${
        data.employmentDetails?.panAadhar ||
        data.employeeDetails?.pan ||
        data.pan ||
        "N/A"
      }`,
      40,
      yPos
    );
    doc.text(
      `Designation: ${
        data.employmentDetails?.designation ||
        data.jobDetails?.designation ||
        data.designation ||
        "N/A"
      }`,
      300,
      yPos
    );
    yPos += 15;
    doc.text(
      `Department: ${
        data.employmentDetails?.department ||
        data.jobDetails?.department ||
        data.department ||
        "N/A"
      }`,
      40,
      yPos
    );
    doc.text(
      `Employer: ${
        data.employmentDetails?.employerName ||
        data.companyDetails?.name ||
        data.employerName ||
        "N/A"
      }`,
      300,
      yPos
    );
    yPos += 15;
    doc.text(
      `Employer Type: ${
        data.employmentDetails?.employerType ||
        data.companyDetails?.type ||
        data.employerType ||
        "N/A"
      }`,
      40,
      yPos
    );
    doc.text(
      `Employment Type: ${
        data.employmentDetails?.employmentType ||
        data.jobDetails?.type ||
        data.employmentType ||
        "N/A"
      }`,
      300,
      yPos
    );
    yPos += 15;
    doc.text(
      `Date of Joining: ${
        data.employmentDetails?.dateOfJoining ||
        data.jobDetails?.joiningDate ||
        data.dateOfJoining ||
        "N/A"
      }`,
      40,
      yPos
    );
    doc.text(
      `Pay Period: ${
        data.payslipDetails?.payPeriod ||
        data.salaryDetails?.payPeriod ||
        data.payPeriod ||
        "N/A"
      }`,
      300,
      yPos
    );
    yPos += 30;

    // Monthly Salary Summary
    doc.setFontSize(14);
    doc.text("Income Structure - Monthly Payslip Summary", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(
      `Basic Salary: Rs ${data.salaryDetails?.basicSalary || "N/A"}`,
      40,
      yPos
    );
    doc.text(`HRA: Rs ${data.salaryDetails?.hra || "N/A"}`, 300, yPos);
    yPos += 15;
    doc.text(
      `Special Allowance: Rs ${data.salaryDetails?.specialAllowance || "N/A"}`,
      40,
      yPos
    );
    doc.text(
      `Conveyance Allowance: Rs ${
        data.salaryDetails?.conveyanceAllowance || "N/A"
      }`,
      300,
      yPos
    );
    yPos += 15;
    doc.text(
      `Medical/LTA Benefits: Rs ${
        data.salaryDetails?.medicalAllowance || "N/A"
      }`,
      40,
      yPos
    );
    doc.text(
      `Performance Bonus: Rs ${data.salaryDetails?.performanceBonus || "N/A"}`,
      300,
      yPos
    );
    yPos += 15;
    doc.text(
      `Gross Monthly Salary: Rs ${
        data.salaryDetails?.grossMonthlySalary || "N/A"
      }`,
      40,
      yPos
    );
    doc.text(
      `Net Take-Home: Rs ${data.salaryDetails?.netTakeHome || "N/A"}`,
      300,
      yPos
    );
    yPos += 30;

    // Deductions Summary
    doc.setFontSize(14);
    doc.text("Deductions Summary", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(
      `Provident Fund (PF): Rs ${data.deductions?.providentFund || "N/A"}`,
      40,
      yPos
    );
    doc.text(`ESI: Rs ${data.deductions?.esi || "0"}`, 300, yPos);
    yPos += 15;
    doc.text(
      `Loan/Advance Deductions: Rs ${
        data.deductions?.loanOrAdvanceDeductions || "0"
      }`,
      40,
      yPos
    );
    doc.text(`Others: Rs ${data.deductions?.others || "N/A"}`, 300, yPos);
    yPos += 15;
    doc.text(
      `TDS/Professional Tax: Rs ${
        data.deductions?.tdsOrProfessionalTax || "N/A"
      }`,
      40,
      yPos
    );
    doc.text(
      `Total Deductions: Rs ${data.deductions?.totalDeductions || "N/A"}`,
      300,
      yPos
    );
    yPos += 30;

    // Employment Strength Scorecard
    doc.setFontSize(14);
    doc.text("Employment Strength Scorecard", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(
      `Income Stability: ${data.employmentScorecard?.incomeStability || "N/A"}`,
      40,
      yPos
    );
    doc.text(
      `Formal Employment: ${
        data.employmentScorecard?.formalEmployment || "N/A"
      }`,
      300,
      yPos
    );
    yPos += 15;
    doc.text(
      `Employer Authenticity: ${
        data.employmentScorecard?.employerAuthenticity || "N/A"
      }`,
      40,
      yPos
    );
    doc.text(
      `Document Format: ${data.employmentScorecard?.documentFormat || "N/A"}`,
      300,
      yPos
    );
    yPos += 15;
    doc.text(
      `Income Eligibility: ${
        data.employmentScorecard?.incomeEligibility || "N/A"
      }`,
      40,
      yPos
    );
    doc.text(
      `Work Experience: ${data.employmentScorecard?.workExperience || "N/A"}`,
      300,
      yPos
    );
    yPos += 30;

    // Final Credit Analyst Verdict
    doc.setFontSize(14);
    doc.text("Final Credit Analyst Verdict", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(
      `Monthly Net Income: Rs ${
        data.finalVerdict?.monthlyNetIncome ||
        data.salaryDetails?.netTakeHome ||
        "N/A"
      }`,
      40,
      yPos
    );
    doc.text(
      `Employment Risk Level: ${
        data.finalVerdict?.employmentRiskLevel || "N/A"
      }`,
      300,
      yPos
    );
    yPos += 30;

    // Final Comments
    doc.setFontSize(14);
    doc.text("Final Comments", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    const comments = data.finalComments || [
      "Employment analysis completed based on available payslip data.",
      "All verification parameters have been assessed.",
      "Recommendation based on income stability and employment verification.",
    ];
    comments.forEach((comment) => {
      doc.text(`• ${comment}`, 40, yPos);
      yPos += 15;
    });

    doc.save("employment-payslip-analysis-report.pdf");
  } catch (error) {
    console.error("PDF generation error:", error);
    alert(`Error generating PDF: ${error.message}`);
  }
};

const EmploymentPayslipAnalysisReport = ({ analysisResult }) => {
  const data =
    analysisResult?.openAIResponse?.results ||
    analysisResult?.analysisData?.results ||
    analysisResult?.results?.[0]?.analysis?.results ||
    {};

  // Debug log to see the actual data structure
  console.log(
    "EmploymentPayslipAnalysisReport - analysisResult:",
    analysisResult
  );
  console.log("EmploymentPayslipAnalysisReport - extracted data:", data);

  const getValue = (path, defaultValue = "N/A") => {
    return (
      path?.split(".").reduce((obj, key) => obj?.[key], data) || defaultValue
    );
  };
  return (
    <div className="bg-[#131313] text-white p-6 text-sm space-y-6 min-h-screen">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-4">
        <div className="w-full sm:max-w-sm">
          <label className="block mb-1 text-sm">Select Analyzer Type</label>
          <select className="w-full bg-[#1f1f1f] border border-[#333] rounded-md px-4 py-2 text-white">
            <option>Universal Employment / Payslip Analyser</option>
          </select>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
          <button
            onClick={() => {
              console.log("Download button clicked", analysisResult);
              console.log("Data being passed to PDF:", data);
              handleDownloadPDF(analysisResult);
            }}
            className="bg-[#FFCA20] hover:bg-[#e6b91a] text-black px-4 py-2 rounded-md font-semibold text-sm"
          >
            Download Report
          </button>
        </div>
      </div>

      {/* Employee & Employer Details */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 space-y-2 border border-[#2a2a2a]">
        <h2 className="text-yellow-400 text-lg font-semibold">
          📄 Employee & Employer Details
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Employee Name</strong>
            <span className="text-white">
              {getValue("employmentDetails.employeeName") ||
                getValue("employeeDetails.name") ||
                getValue("employeeName")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Employee ID</strong>
            <span className="text-white">
              {getValue("employmentDetails.employeeId") ||
                getValue("employeeDetails.id") ||
                getValue("employeeId")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">PAN / Aadhar</strong>
            <span className="text-white">
              {getValue("employmentDetails.panAadhar") ||
                getValue("employeeDetails.pan") ||
                getValue("pan")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Designation</strong>
            <span className="text-white">
              {getValue("employmentDetails.designation") ||
                getValue("jobDetails.designation") ||
                getValue("designation")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Department</strong>
            <span className="text-white">
              {getValue("employmentDetails.department") ||
                getValue("jobDetails.department") ||
                getValue("department")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Company Name</strong>
            <span className="text-white">
              {getValue("employmentDetails.employerName") ||
                getValue("companyDetails.name") ||
                getValue("employerName")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Employer Type</strong>
            <span className="text-white">
              {getValue("employmentDetails.employerType") ||
                getValue("companyDetails.type") ||
                getValue("employerType")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Employment Type</strong>
            <span className="text-white">
              {getValue("employmentDetails.employmentType") ||
                getValue("jobDetails.type") ||
                getValue("employmentType")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Date of Joining</strong>
            <span className="text-white">
              {getValue("employmentDetails.dateOfJoining") ||
                getValue("jobDetails.joiningDate") ||
                getValue("dateOfJoining")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Pay Period Covered</strong>
            <span className="text-white">
              {getValue("payslipDetails.payPeriod") ||
                getValue("salaryDetails.payPeriod") ||
                getValue("payPeriod")}
            </span>
          </div>
        </div>
      </div>

      {/* Monthly Salary Summary */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <IndianRupee size={18} /> Income Structure – Monthly Payslip Summary
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Basic Salary</strong>
              <span className="text-yellow-400">
                ₹
                {data.salaryDetails?.basicSalary?.toLocaleString("en-IN") ||
                  "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">HRA</strong>
              <span className="text-yellow-400">
                ₹{data.salaryDetails?.hra?.toLocaleString("en-IN") || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Special Allowance</strong>
              <span className="text-yellow-400">
                ₹
                {data.salaryDetails?.specialAllowance?.toLocaleString(
                  "en-IN"
                ) || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Gross Monthly Salary</strong>
              <span className="text-green-400">
                ₹
                {data.salaryDetails?.grossMonthlySalary?.toLocaleString(
                  "en-IN"
                ) || "N/A"}
              </span>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Conveyance Allowance</strong>
              <span className="text-white">
                ₹
                {data.salaryDetails?.conveyanceAllowance?.toLocaleString(
                  "en-IN"
                ) || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Medical/LTA Benefits</strong>
              <span className="text-white">
                ₹
                {data.salaryDetails?.medicalAllowance?.toLocaleString(
                  "en-IN"
                ) || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Performance Bonus</strong>
              <span className="text-white">
                ₹
                {data.salaryDetails?.performanceBonus?.toLocaleString(
                  "en-IN"
                ) || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Net Take-Home</strong>
              <span className="text-blue-400">
                ₹
                {data.salaryDetails?.netTakeHome?.toLocaleString("en-IN") ||
                  "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Deductions */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <BadgeCheck size={18} /> Deductions Summary
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Provident Fund (PF)</strong>
              <span className="text-white">
                ₹
                {data.deductions?.providentFund?.toLocaleString("en-IN") ||
                  "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">
                Loan/Advance Deductions
              </strong>
              <span className="text-white">
                ₹
                {data.deductions?.loanOrAdvanceDeductions?.toLocaleString(
                  "en-IN"
                ) || "0"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">ESI</strong>
              <span className="text-white">
                ₹{data.deductions?.esi?.toLocaleString("en-IN") || "0"}
              </span>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Others</strong>
              <span className="text-white">
                ₹{data.deductions?.others?.toLocaleString("en-IN") || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">TDS / Professional Tax</strong>
              <span className="text-white">
                ₹
                {data.deductions?.tdsOrProfessionalTax?.toLocaleString(
                  "en-IN"
                ) || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Total Deductions</strong>
              <span className="text-red-400">
                ₹
                {data.deductions?.totalDeductions?.toLocaleString("en-IN") ||
                  "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Income Consistency (Multiple Payslips) */}
      {data?.incomeConsistency && data.incomeConsistency.length > 0 ? (
        <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a]">
          <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
            <TrendingUp size={18} /> Income Consistency (Multiple Payslips)
          </div>
          <div className="overflow-x-auto scrollbar-hide">
            <table className="w-full mt-3 text-sm min-w-[600px] border-collapse">
              <thead className="text-[#AAAAAA]">
                <tr>
                  <th className="text-left">Month</th>
                  <th className="text-left">Gross Salary</th>
                  <th className="text-left">Net Salary</th>
                  <th className="text-left">Total Deductions</th>
                  <th className="text-left">Variance vs Previous</th>
                </tr>
              </thead>
              <tbody>
                {data.incomeConsistency.map((record, i) => (
                  <tr key={i}>
                    <td>{record.month || "N/A"}</td>
                    <td>
                      ₹
                      {record.grossMonthlySalary?.toLocaleString("en-IN") ||
                        "N/A"}
                    </td>
                    <td>
                      ₹{record.netTakeHome?.toLocaleString("en-IN") || "N/A"}
                    </td>
                    <td>
                      ₹
                      {record.totalDeductions?.toLocaleString("en-IN") || "N/A"}
                    </td>
                    <td
                      className={
                        record.variance === "Increase"
                          ? "text-green-400"
                          : record.variance === "Decrease"
                          ? "text-red-400"
                          : "text-gray-300"
                      }
                    >
                      {record.variance || "N/A"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      ) : (
        <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a] text-center text-[#AAAAAA]">
          <div className="flex justify-center items-center gap-2 text-yellow-400 font-semibold text-lg">
            <TrendingUp size={18} /> Income Consistency (Multiple Payslips)
          </div>
          <p className="mt-3 text-sm text-gray-400">
            No multiple payslip data available for comparison.
          </p>
        </div>
      )}

      {/* Verification Parameters */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <UserCheck size={18} /> Employment Verification Parameters
        </div>
        <div className="overflow-x-auto scrollbar-hide">
          <table className="w-full mt-3 text-sm min-w-[500px] border-collapse">
            <thead className="text-[#AAAAAA]">
              <tr>
                <th className="text-left">Parameter</th>
                <th className="text-left">Value</th>
                <th className="text-left">Status</th>
              </tr>
            </thead>
            <tbody>
              {(
                data.verificationParameters || [
                  {
                    parameter: "Company Name Matches KYC/ITR",
                    value: "Yes",
                    status: "Verified",
                  },
                  {
                    parameter: "Salary Credited to Bank Account",
                    value: "Yes",
                    status: "Verified",
                  },
                  {
                    parameter: "Salary Mode",
                    value: "Bank Transfer",
                    status: "Verified",
                  },
                  {
                    parameter: "PAN/Aadhaar on Payslip",
                    value: "Yes",
                    status: "Verified",
                  },
                  {
                    parameter: "UAN/PF Number Visible",
                    value: "Yes",
                    status: "Verified",
                  },
                  {
                    parameter: "Company Letterhead/Email",
                    value: "Yes",
                    status: "Verified",
                  },
                  {
                    parameter: "HR/Manager Contact Details",
                    value: "Yes",
                    status: "Verified",
                  },
                  {
                    parameter: "TDS Deducted",
                    value: "Yes",
                    status: "Verified",
                  },
                  {
                    parameter: "PF Deduction Present",
                    value: "Yes",
                    status: "Verified",
                  },
                  {
                    parameter: "Payslip Format",
                    value: "System-Generated",
                    status: "Verified",
                  },
                ]
              ).map((param, i) => (
                <tr key={i}>
                  <td>{param.parameter}</td>
                  <td>{param.value}</td>
                  <td
                    className={
                      param.status === "Verified"
                        ? "text-green-400"
                        : "text-red-400"
                    }
                  >
                    {param.status}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>

      {/* Employment Strength Scorecard */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a] text-center">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <Building2 size={18} /> Employment Strength Scorecard
        </div>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mt-4">
          <div>
            <strong className="text-[#AAAAAA]">Income Stability</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.employmentScorecard?.incomeStability || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Formal Employment</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.employmentScorecard?.formalEmployment || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Employer Authenticity</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.employmentScorecard?.employerAuthenticity || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Document Format</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.employmentScorecard?.documentFormat || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Income Eligibility</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.employmentScorecard?.incomeEligibility || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Work Experience</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.employmentScorecard?.workExperience || "N/A"}
            </span>
          </div>
        </div>
      </div>

      {/* Final Verdict */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 border border-[#2a2a2a] text-center">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <TrendingUp size={18} /> Final Credit Analyst Verdict
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
          <div>
            <strong className="text-[#AAAAAA]">Monthly Net Income</strong>
            <br />
            <span className="text-green-400 text-lg">
              ₹
              {data.finalVerdict?.monthlyNetIncome?.toLocaleString("en-IN") ||
                data.salaryDetails?.netTakeHome?.toLocaleString("en-IN") ||
                "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Employment Risk Level</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.finalVerdict?.employmentRiskLevel || "N/A"}
            </span>
          </div>
        </div>
      </div>

      {/* Final Comments */}
      <div className="bg-green-950 border border-green-600 rounded-lg p-4 text-green-400">
        <h3 className="font-semibold text-green-500 mb-2">📝 Final Comments</h3>
        <ul className="list-disc pl-5 space-y-1">
          {data.finalComments?.map((comment, index) => (
            <li key={index}>{comment}</li>
          )) || [
            <li key="default1">
              Employment analysis completed based on available payslip data.
            </li>,
            <li key="default2">
              All verification parameters have been assessed.
            </li>,
            <li key="default3">
              Recommendation based on income stability and employment
              verification.
            </li>,
          ]}
        </ul>
      </div>
    </div>
  );
};

export default EmploymentPayslipAnalysisReport;
